const INITIAL_STATE = {
  errors: {},
  customerList: {},
  customerReport: {}
}
  
const CustomerStatementReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, customerList: action.data }
  case 'GET_CUSTOMER_STATEMENT_CUSTOMER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_STATEMENT_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, customerReport: action.data }
  case 'GET_CUSTOMER_STATEMENT_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default CustomerStatementReport;